import React from 'react'
import logo from '../../logo-red.svg'

interface LogoProps {
  className?: string
  showText?: boolean
  textClassName?: string
  logoClassName?: string
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  showText = true,
  textClassName = '',
  logoClassName = '',
}) => {
  return (
    <div className={`logo-container ${className}`}>
      <img
        src={logo}
        alt="BreadGPT"
        className={`logo-image ${logoClassName}`}
      />
      {showText && <h1 className={`logo-title ${textClassName}`}>BreadGPT</h1>}
    </div>
  )
}

export default Logo
